import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LMPageOverlayService {
  /**
   * Service to display a page overlay with busy indicator from the bootstrap angularcli.html file.
   * This allows a busy indicator to display before a component is loaded.
   */
  private overlayVisible = new BehaviorSubject<boolean>(false);
  private overlayUsageCount = 0;

  /**
   * Shows the overlay.
   * Increments a usage counter to track how many times the overlay is being used.
   */
  showOverlay(): void {
    const overlay = document.getElementById('lm-page-overlay');
    if (!overlay) {
      return;
    }

    this.overlayUsageCount++;

    if (this.overlayUsageCount === 1) { // First time requesting the overlay, make it visible
      overlay.style.display = 'block';
      overlay.style.zIndex = '999999';
      this.overlayVisible.next(true);
    }
  }

  /**
   * Hides the overlay.
   * Decrements the usage counter and only hides the overlay when the count reaches zero.
   */
  hideOverlay(): void {
    const overlay = document.getElementById('lm-page-overlay');
    if (!overlay) {
      return;
    }

    this.overlayUsageCount--;

    if (this.overlayUsageCount <= 0) {
      this.overlayUsageCount = 0; // Ensure count doesn't go negative
      overlay.style.display = 'none';
      overlay.style.zIndex = '-1';
      this.overlayVisible.next(false);
    }
  }

  /**
   * Checks if the overlay is currently visible.
   */
  isOverlayVisible(): boolean {
    return this.overlayVisible.getValue();
  }
}